// import { useState } from "react";
// import css from "./adm.module.css";
// import PopupEditorWeHelpChooseBook from "./popUps/PopupEditorWeHelpChooseBook";
// import PopupEditorRada from "./popUps/PopupEditorRada";
// import PopupEditorClubMasters from "./popUps/PopupEditorClubMasters";
// import PopupEditorEurope from "./popUps/PopupEditorEurope";
// import PopupEditorSPCorporate from "./popUps/PopupEditorSPCorporate";
// import PopupEditorDropshipping from "./popUps/PopupEditorDropshipping";
// import PopupEditorLibraries from "./popUps/PopupEditorLibraries";
// import PopupEditorSalesSupport from "./popUps/PopupEditorSalesSupport";
// import PopupEditorMainBird from "./popUps/PopupEditorMainBird";
// import PopupEditorMission from "./popUps/PopupEditorMission";import PopupEditorSubscribeDiscount from "./popUps/PopupEditorSubscribeDiscount";
// const AllPop = () => {
//   const [popHelp, setPopHelp] = useState(false);
//   const [popOpicun, setPopOpicun] = useState(false);
//   const [popClub, setPopClub] = useState(false);
//   const [popChM, setPopChM] = useState(false);
//   const [popSp, setPopSp] = useState(false);
//   const [popDrop, setPopDrop] = useState(false);
//   const [popBiblio, setPopBiblio] = useState(false);
//   const [popSuport, setPopSuport] = useState(false);
//   const [popPtah, setPopPtah] = useState(false);
//   const [popChasHeader, setPopChasHeader] = useState(false);
//   const funcHelp = () => {
//     setPopHelp(!popHelp);
//     setPopOpicun(false);
//     setPopClub(false);
//     setPopChM(false);
//     setPopSp(false);
//     setPopDrop(false);
//     setPopBiblio(false);
//     setPopSuport(false);
//     setPopPtah(false);
//     setPopChasHeader(false);
//   };
//   const funcOpicun = () => {
//     setPopHelp(false);
//     setPopOpicun(!popOpicun);
//     setPopClub(false);
//     setPopChM(false);
//     setPopSp(false);
//     setPopDrop(false);
//     setPopBiblio(false);
//     setPopSuport(false);
//     setPopPtah(false);
//     setPopChasHeader(false);
//   };
//   const funcClub = () => {
//     setPopHelp(false);
//     setPopOpicun(false);
//     setPopClub(!popClub);
//     setPopChM(false);
//     setPopSp(false);
//     setPopDrop(false);
//     setPopBiblio(false);
//     setPopSuport(false);
//     setPopPtah(false);
//     setPopChasHeader(false);
//   };
//   const funcChM = () => {
//     setPopHelp(false);
//     setPopOpicun(false);
//     setPopClub(false);
//     setPopChM(!popChM);
//     setPopSp(false);
//     setPopDrop(false);
//     setPopBiblio(false);
//     setPopSuport(false);
//     setPopPtah(false);
//     setPopChasHeader(false);
//   };
//   const funcSp = () => {
//     setPopHelp(false);
//     setPopOpicun(false);
//     setPopClub(false);
//     setPopChM(false);
//     setPopSp(!popSp);
//     setPopDrop(false);
//     setPopBiblio(false);
//     setPopSuport(false);
//     setPopPtah(false);
//     setPopChasHeader(false);
//   };
//   const funcDrop = () => {
//     setPopHelp(false);
//     setPopOpicun(false);
//     setPopClub(false);
//     setPopChM(false);
//     setPopSp(false);
//     setPopDrop(!popDrop);
//     setPopBiblio(false);
//     setPopSuport(false);
//     setPopPtah(false);
//     setPopChasHeader(false);
//   };
//   const funcBiblio = () => {
//     setPopHelp(false);
//     setPopOpicun(false);
//     setPopClub(false);
//     setPopChM(false);
//     setPopSp(false);
//     setPopDrop(false);
//     setPopBiblio(!popBiblio);
//     setPopSuport(false);
//     setPopPtah(false);
//     setPopChasHeader(false);
//   };
//   const funcSuport = () => {
//     setPopHelp(false);
//     setPopOpicun(false);
//     setPopClub(false);
//     setPopChM(false);
//     setPopSp(false);
//     setPopDrop(false);
//     setPopBiblio(false);
//     setPopSuport(!popSuport);
//     setPopPtah(false);
//     setPopChasHeader(false);
//   };
//   const funcPtah = () => {
//     setPopHelp(false);
//     setPopOpicun(false);
//     setPopClub(false);
//     setPopChM(false);
//     setPopSp(false);
//     setPopDrop(false);
//     setPopBiblio(false);
//     setPopSuport(false);
//     setPopPtah(!popPtah);
//     setPopChasHeader(false);
//   };
//   const funcChasHeader = () => {
//     setPopHelp(false);
//     setPopOpicun(false);
//     setPopClub(false);
//     setPopChM(false);
//     setPopSp(false);
//     setPopDrop(false);
//     setPopBiblio(false);
//     setPopSuport(false);
//     setPopPtah(false);
//     setPopChasHeader(!popChasHeader);
//   };
//   return (
//     <div className={css.wrapAllPop}>
//       <ul className={css.ulForListPop}>
//         <li onClick={funcPtah} className={css.wrapLiInPopFor}>
//           Пташка Час Майстрів
//         </li>
//         <li onClick={funcChasHeader} className={css.wrapLiInPopFor}>
//           Напис Час Майстрів в шапці
//         </li>
//         <li onClick={funcHelp} className={css.wrapLiInPopFor}>
//           Допомагаємо обрати книгу
//         </li>
//         <li onClick={funcOpicun} className={css.wrapLiInPopFor}>
//           Що таке опікунська рада
//         </li>
//         <li onClick={funcClub} className={css.wrapLiInPopFor}>
//           Клуб Майстрів
//         </li>
//         <li onClick={funcChM} className={css.wrapLiInPopFor}>
//           Книги ЧМ в Європі
//         </li>
//         <li onClick={funcSp} className={css.wrapLiInPopFor}>
//           СП/Корпоративні/на групу/на клас
//         </li>{" "}
//         <li onClick={funcDrop} className={css.wrapLiInPopFor}>
//           Дропшипінг
//         </li>
//         <li onClick={funcBiblio} className={css.wrapLiInPopFor}>
//           Підтримка бібліотек і бібліотекарів
//         </li>
//         <li onClick={funcSuport} className={css.wrapLiInPopFor}>
//           Підтримка продавців-консультантів
//         </li>
//       </ul>
//       {popHelp && <PopupEditorWeHelpChooseBook />}
//       {popOpicun && <PopupEditorRada />}
//       {popClub && <PopupEditorClubMasters />}
//       {popChM && <PopupEditorEurope />}
//       {popSp && <PopupEditorSPCorporate />}
//       {popDrop && <PopupEditorDropshipping />}
//       {popBiblio && <PopupEditorLibraries />}
//       {popSuport && <PopupEditorSalesSupport />}
//       {popPtah && <PopupEditorMainBird />}
//       {popChasHeader && <PopupEditorMission />}
//     </div>
//   );
// };
// export default AllPop;
import { useState } from "react";
import css from "./adm.module.css";

import PopupEditorWeHelpChooseBook from "./popUps/PopupEditorWeHelpChooseBook";
import PopupEditorRada from "./popUps/PopupEditorRada";
import PopupEditorClubMasters from "./popUps/PopupEditorClubMasters";
import PopupEditorEurope from "./popUps/PopupEditorEurope";
import PopupEditorSPCorporate from "./popUps/PopupEditorSPCorporate";
import PopupEditorDropshipping from "./popUps/PopupEditorDropshipping";
import PopupEditorLibraries from "./popUps/PopupEditorLibraries";
import PopupEditorSalesSupport from "./popUps/PopupEditorSalesSupport";
import PopupEditorMainBird from "./popUps/PopupEditorMainBird";
import PopupEditorMission from "./popUps/PopupEditorMission";
import PopupEditorSubscribeDiscount from "./popUps/PopupEditorSubscribeDiscount";

const AllPop = () => {
  const [activePop, setActivePop] = useState(null);

  const togglePop = (key) => {
    setActivePop((prev) => (prev === key ? null : key));
  };

  return (
    <div className={css.wrapAllPop}>
      <ul className={css.ulForListPop}>
        <li onClick={() => togglePop("ptah")} className={css.wrapLiInPopFor}>
          Пташка Час Майстрів
        </li>

        <li
          onClick={() => togglePop("chasHeader")}
          className={css.wrapLiInPopFor}
        >
          Напис Час Майстрів в шапці
        </li>

        <li onClick={() => togglePop("help")} className={css.wrapLiInPopFor}>
          Допомагаємо обрати книгу
        </li>

        <li
          onClick={() => togglePop("subscribeDiscount")}
          className={css.wrapLiInPopFor}
        >
          Попап підписки / знижки
        </li>

        <li onClick={() => togglePop("opicun")} className={css.wrapLiInPopFor}>
          Що таке опікунська рада
        </li>

        <li onClick={() => togglePop("club")} className={css.wrapLiInPopFor}>
          Клуб Майстрів
        </li>

        <li onClick={() => togglePop("chM")} className={css.wrapLiInPopFor}>
          Книги ЧМ в Європі
        </li>

        <li onClick={() => togglePop("sp")} className={css.wrapLiInPopFor}>
          СП/Корпоративні/на групу/на клас
        </li>

        <li onClick={() => togglePop("drop")} className={css.wrapLiInPopFor}>
          Дропшипінг
        </li>

        <li onClick={() => togglePop("biblio")} className={css.wrapLiInPopFor}>
          Підтримка бібліотек і бібліотекарів
        </li>

        <li onClick={() => togglePop("suport")} className={css.wrapLiInPopFor}>
          Підтримка продавців-консультантів
        </li>
      </ul>

      {activePop === "help" && <PopupEditorWeHelpChooseBook />}
      {activePop === "opicun" && <PopupEditorRada />}
      {activePop === "club" && <PopupEditorClubMasters />}
      {activePop === "chM" && <PopupEditorEurope />}
      {activePop === "sp" && <PopupEditorSPCorporate />}
      {activePop === "drop" && <PopupEditorDropshipping />}
      {activePop === "biblio" && <PopupEditorLibraries />}
      {activePop === "suport" && <PopupEditorSalesSupport />}
      {activePop === "ptah" && <PopupEditorMainBird />}
      {activePop === "chasHeader" && <PopupEditorMission />}
      {activePop === "subscribeDiscount" && <PopupEditorSubscribeDiscount />}
    </div>
  );
};

export default AllPop;
